import React from 'react';
import { Box } from '@mui/material';

import HomeBottomButtonOptionsCam from '@core/dashboard/components/HomeBottomBar/HomeBottomButtonOptionsCam';
import HomeBottomButtonOptionsSettings from '@core/dashboard/components/HomeBottomBar/HomeBottomButtonOptionsSettings';
import { useConferenceState } from '@hooks/conferenceContext';
import { useCommunications } from '@core/communications/providers/CommunicationsProvider';

import { useStyles } from './styles';
import LoadingProgress from '@components/LoadingProgress';

const VideoComponent = ({ cameraDeviceId }: { cameraDeviceId: string }) => {
  const { setActiveCameraDeviceId } = useConferenceState();
  const { cameraList } = useCommunications();

  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      <Box sx={classes.video}>
        <Box sx={classes.loading}>
          <LoadingProgress />
        </Box>
        <HomeBottomButtonOptionsCam selectedCam={cameraDeviceId} />
      </Box>

      <HomeBottomButtonOptionsSettings
        devices={cameraList}
        handleSelect={(e) => setActiveCameraDeviceId(e.target.value)}
        selectedValue={cameraDeviceId}
        sx={classes.select}
      />
    </Box>
  );
};

export default VideoComponent;
